// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*************** Width Styles *****************/
.w-5 {
  width: 5%;
}

.w-7 {
  width: 7%;
}

.w-10 {
  width: 10%;
}

.w-13 {
  width: 13%;
}

.w-16 {
  width: 16%;
}

.w-19 {
  width: 19%;
}

.w-14 {
  width: 14%;
}

.w-17 {
  width: 17%;
}

.w-20 {
  width: 20%;
}

.w-21 {
  width: 21%;
}

.w-22 {
  width: 22%;
}

.w-25 {
  width: 25%;
}

.w-27 {
  width: 27%;
}

.w-28 {
  width: 28%;
}

.w-30 {
  width: 30%;
}

.w-33 {
  width: 33%;
}

.w-36 {
  width: 36%;
}

.w-40 {
  width: 40%;
}

.w-45 {
  width: 45%;
}

.w-46 {
  width: 46%;
}

.w-49 {
  width: 49%;
}

.w-50 {
  width: 50%;
}

.w-54 {
  width: 54%;
}

.w-55 {
  width: 55%;
}

.w-60 {
  width: 60%;
}

.w-70 {
  width: 70%;
}

.w-73 {
  width: 73%;
}

.w-79 {
  width: 79%;
}

.w-80 {
  width: 80%;
}

.w-83 {
  width: 83%;
}

.w-85 {
  width: 85%;
}

.w-86 {
  width: 86%;
}

.w-87 {
  width: 87%;
}

.w-90 {
  width: 90%;
}

.w-93 {
  width: 93%;
}

.w-95 {
  width: 95%;
}

.w-96 {
  width: 96%;
}

.w-98 {
  width: 98%;
}

.w-100 {
  width: 100%;
}

.w-30px {
  width: 30px;
}

.w-40px {
  width: 30px;
}

.w-48px {
  width: 48px;
}

.w-50px {
  width: 50px;
}

.w-55px {
  width: 55px;
}

.w-60px {
  width: 60px;
}

.w-70px {
  width: 70px;
}

.w-80px {
  width: 80px !important;
}

.w-100px {
  width: 100px;
}

.w-130px {
  width: 130px;
}

.w-335px {
  width: 335px;
}

/*************** Height Styles *****************/
.h-0 {
  height: 0px;
}

.h-8px {
  height: 8px;
}

.h-13px {
  height: 13px;
}

.h-25px {
  height: 25px !important;
}

.h-30px {
  height: 30px;
}

.h-55px {
  height: 55px;
}

.h-70px {
  height: 70px;
}

.h-100px {
  height: 100px;
}

.h-100 {
  height: 100%;
}

.h-70vh {
  height: 70vh;
}

.h-120 {
  height: 120px;
}

.min-hieght-100vh {
  min-height: 100vh;
}

/*************** Display Styles *****************/
.d-none {
  display: none;
}

.d-block {
  display: block !important;
}

.d-inline-block {
  display: inline-block;
}

.d-flex {
  display: flex;
}

.d-grid {
  display: grid;
}

/*************** Gap Styles *****************/
.gap-15 {
  gap: 15px;
}

/*************** Flex direction Styles *****************/
.flex-direction-column {
  flex-direction: column;
}

/*************** Flex Styles *****************/
.flex-wrap {
  flex-wrap: wrap;
}

/*************** Align content Styles *****************/
.align-content-center {
  align-content: center;
}

/*************** Align items Styles *****************/
.align-items-start {
  align-items: start;
}

.align-items-end {
  align-items: end;
}

.align-items-center {
  align-items: center;
}

.align-items-baseline {
  align-items: baseline;
}

/*************** Float Styles *****************/
.f-left {
  float: left;
}

.f-right {
  float: right;
}

/*************** Text Alignment Styles *****************/
.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

/*************** Text Color Styles *****************/
.color-white {
  color: white;
}

.color-red {
  color: #FF3B30;
}

.color-green {
  color: #58C3BB;
}

.color-007AFF {
  color: #007AFF;
}

.color-4FADA6 {
  color: #4FADA6;
}

.color-EF374E {
  color: #EF374E;
}

.color-black {
  color: black !important;
}

.color-8298B5 {
  color: #8298B5;
}

.color-717171 {
  color: #717171;
}

.color-08142f {
  color: #08142f;
}

.color-58C3BB {
  color: #58C3BB;
}

.color-ABE1DD {
  color: #ABE1DD;
}

.color-F8E58A {
  color: #F8E58A;
}

.color-F79BA6 {
  color: #F79BA6;
}

.color-CC3044 {
  color: #CC3044;
}

.color-1F1F1F {
  color: #1F1F1F;
}

.color-919191 {
  color: #919191 !important;
}

.color-071C3E {
  color: #071C3E;
}

.color-979797 {
  color: #979797;
}

.color-757575 {
  color: #757575;
}

.color-15192080-important {
  color: rgba(21, 25, 32, 0.5019607843) !important;
}

.color-031C38 {
  color: #031C38;
}

/*************** Background Color Styles *****************/
.background-white {
  background-color: white;
}

.background-EEF9F8 {
  background-color: #EEF9F8;
}

.background-FDEBED {
  background-color: #FDEBED;
}

.background-f1f1f1 {
  background: #f1f1f1;
}

.background-f7f8f8 {
  background: #f7f8f8;
}

.background-08142f {
  background: #08142f;
}

.background-E1E1E1 {
  background: #E1E1E1;
}

.background-none {
  background: none;
}

.background-58C3BB {
  background: #58C3BB;
}

.background-ABE1DD {
  background: #ABE1DD;
}

.background-EEF9F8 {
  background: #EEF9F8;
}

.background-F8E58A {
  background: #F8E58A;
}

.background-F79BA6 {
  background: #F79BA6;
}

.background-CC3044 {
  background: #CC3044;
}

.background-EF374E {
  background: #EF374E;
}

.background-4FADA6 {
  background: #4FADA6;
}

.background-071C3E {
  background: #071C3E;
}

.background-717171 {
  background: #717171;
}

.background-DEBA12 {
  background: #DEBA12;
}

.background-1F1F1F {
  background: #1F1F1F;
}

.background-8298B5 {
  background: #8298B5;
}

.background-919191 {
  background: #919191;
}

.background-F2CB15 {
  background: #F2CB15;
}

.background-071C3E-important {
  background: #071C3E !important;
}

.background-F5F7FB-important {
  background: #F5F7FB !important;
}

/*************** Fill Color Styles *****************/
.fill-58c3bb {
  fill: #58c3bb;
}

.fill-white {
  fill: white;
}

.fill-979797 {
  fill: #979797;
}

.fill-919191 {
  fill: #919191;
}

.fill-white {
  fill: #fff;
}

/*************** Font Size Styles *****************/
.f-10 {
  font-size: 10px !important;
}

.f-12 {
  font-size: 12px !important;
}

.f-13 {
  font-size: 13px;
}

.f-14 {
  font-size: 14px !important;
}

.f-15 {
  font-size: 15px !important;
}

.f-17 {
  font-size: 17px;
}

.f-18 {
  font-size: 18px;
}

.f-20 {
  font-size: 20px;
}

.f-22 {
  font-size: 22px;
}

.f-24 {
  font-size: 24px;
}

.f-28 {
  font-size: 28px;
}

/*************** Font Weight Styles *****************/
.fw-600 {
  font-weight: 600 !important;
}

.fw-400 {
  font-weight: 400 !important;
}

.fw-bold {
  font-weight: bold;
}

/*************** Font Styles *****************/
.font-normal {
  font-style: normal;
}

.font-italic {
  font-style: italic;
}

.sans-font {
  font-family: "Source Sans Pro";
}

.times-roman {
  font-family: "Times New Roman";
}

/*************** Line Height Styles *****************/
.lh-unset {
  line-height: unset !important;
}

.lh-12 {
  line-height: 12px;
}

.lh-16 {
  line-height: 16px !important;
}

.lh-18 {
  line-height: 18px !important;
}

.lh-20 {
  line-height: 20px;
}

.lh-22 {
  line-height: 22px;
}

.lh-24 {
  line-height: 24px;
}

.lh-25 {
  line-height: 25px;
}

.lh-28 {
  line-height: 28px;
}

.lh-34 {
  line-height: 34px;
}

/*************** Padding Styles *****************/
.p-0 {
  padding: 0;
}

.p-5 {
  padding: 5px;
}

.p-10 {
  padding: 10px;
}

.p-15 {
  padding: 15px;
}

.p-17 {
  padding: 15px;
}

.p-20 {
  padding: 20px;
}

.p-26 {
  padding: 26px;
}

.pl-2 {
  padding-left: 2px;
}

.pl-3 {
  padding-left: 3px;
}

.pl-5 {
  padding-left: 5px;
}

.pl-10 {
  padding-left: 10px;
}

.pl-15 {
  padding-left: 15px;
}

.pl-20 {
  padding-left: 20px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pb-6 {
  padding-bottom: 6px;
}

.pb-10 {
  padding-bottom: 10px;
}

.pb-15 {
  padding-bottom: 15px;
}

.pb-20 {
  padding-bottom: 20px;
}

.pb-25 {
  padding-bottom: 25px;
}

.pb-50 {
  padding-bottom: 50px;
}

.pb-70 {
  padding-bottom: 70px;
}

.pt-3 {
  padding-top: 3px;
}

.pt-5 {
  padding-top: 5px;
}

.pt-6 {
  padding-top: 6px;
}

.pt-10 {
  padding-top: 10px;
}

.pt-12 {
  padding-top: 12px;
}

.pt-15 {
  padding-top: 15px;
}

.pt-20 {
  padding-top: 20px;
}

.pt-25 {
  padding-top: 25px;
}

.pt-30 {
  padding-top: 30px;
}

.pt-35 {
  padding-top: 35px;
}

.pt-80 {
  padding-top: 80px;
}

.pt-120 {
  padding-top: 120px;
}

.pt-180 {
  padding-top: 180px;
}

.pt-190 {
  padding-top: 190px;
}

.pt-200 {
  padding-top: 200px;
}

.pb-5 {
  padding-bottom: 5px;
}

.pb-15 {
  padding-bottom: 15px;
}

.pb-60 {
  padding-bottom: 60px;
}

.pb-85 {
  padding-bottom: 85px;
}

.pb-100 {
  padding-bottom: 100px;
}

.pb-280 {
  padding-bottom: 280px;
}

.pr-0 {
  padding-right: 0px;
}

.pr-2 {
  padding-right: 2px;
}

.pr-3 {
  padding-right: 3px;
}

.pr-5 {
  padding-right: 5px;
}

.pr-10 {
  padding-right: 10px;
}

.pr-15 {
  padding-right: 15px;
}

.pr-22 {
  padding-right: 22px;
}

.pr-20 {
  padding-right: 20px;
}

/*************** Margin Styles *****************/
.m-0 {
  margin: 0px;
}

.m-3 {
  margin: 3px;
}

.m-5 {
  margin: 5px;
}

.m-7 {
  margin: 7px;
}

.m-10 {
  margin: 10px;
}

.m-15 {
  margin: 15px;
}

.m-0-auto {
  margin: 0px auto;
}

.mt-0 {
  margin-top: 0px;
}

.mt-5 {
  margin-top: 5px;
}

.mt-10 {
  margin-top: 10px;
}

.mt-15 {
  margin-top: 10px;
}

.mt-20 {
  margin-top: 20px;
}

.mt-30 {
  margin-top: 30px;
}

.mt-40 {
  margin-top: 40px;
}

.mt-60 {
  margin-top: 60px;
}

.mt-80 {
  margin-top: 80px;
}

.mt-95 {
  margin-top: 95px;
}

.mt-130 {
  margin-top: 130px;
}

.mt-150 {
  margin-top: 150px;
}

.mt-165 {
  margin-top: 165px;
}

.mt-170 {
  margin-top: 170px;
}

.mt-175 {
  margin-top: 175px;
}

.mt-200 {
  margin-top: 200px;
}

.mtn-20px {
  margin-top: -20px;
}

.mb-0 {
  margin-bottom: 0px;
}

.mb-1-5rem {
  margin-bottom: 1.5rem;
}

.mt-1-5rem {
  margin-top: 1.5rem;
}

.mb-5 {
  margin-bottom: 5px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mb-15 {
  margin-bottom: 15px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-30 {
  margin-bottom: 30px;
}

.mb-60 {
  margin-bottom: 60px;
}

.mb-70 {
  margin-bottom: 70px;
}

.ml-10p {
  margin-left: 10%;
}

.ml-5 {
  margin-left: 5px;
}

.ml-10 {
  margin-left: 10px;
}

.ml-15 {
  margin-left: 15px;
}

.ml-20 {
  margin-left: 20px;
}

.mln-10px {
  margin-left: -10px;
}

.mr-5 {
  margin-right: 5px;
}

.mr-10 {
  margin-right: 10px;
}

.mr-12 {
  margin-right: 12px;
}

.mr-15 {
  margin-right: 15px;
}

.mr-22 {
  margin-right: 22px;
}

.mr-30 {
  margin-right: 30px;
}

.mrn-10px {
  margin-right: -10px;
}

/*************** Border Styles *****************/
.black-border-1 {
  border: 1px solid #E1E1E1;
}

.border-grey-1 {
  border: 1px solid #E1E1E1 !important;
}

.border-bottom-grey-1 {
  border-bottom: 1px solid lightgrey;
}

.border-top-d1dbec-1 {
  border-top: 1px solid #d1dbec;
}

.border-right-1 {
  border-right: 1px solid;
}

.border-1 {
  border: 1px solid !important;
}

.border-radius-4 {
  border-radius: 4px;
}

.border-radius-5 {
  border-radius: 5px;
}

.border-radius-7 {
  border-radius: 7px;
}

.border-radius-8 {
  border-radius: 8px;
}

.border-radius-10 {
  border-radius: 10px;
}

.border-radius-60 {
  border-radius: 60px !important;
}

.box-shadow {
  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13);
}

.box-none {
  box-shadow: none !important;
  margin-bottom: 10px;
}

/*************** Text Decoration Styles *****************/
.text-underline {
  text-decoration: underline;
}

.text-none {
  text-decoration: none;
}

/*************** Position Styles *****************/
.position-absolute {
  position: absolute;
}

.position-fixed {
  position: fixed;
}

.position-relative {
  position: relative;
}

.top-3 {
  top: -3px;
}

.top-10 {
  top: 10px;
}

.top-20 {
  top: 20px;
}

.top-100 {
  top: 100px;
}

.top-200 {
  top: 200px;
}

.top-350px {
  top: -350px;
}

.bottom-1 {
  bottom: 1px;
}

.right-7 {
  right: 7px;
}

.right-10 {
  right: 10px;
}

.right-19 {
  right: 19px;
}

.right-25 {
  right: 25px;
}

.left-25 {
  left: 25px;
}

.zIndex-1 {
  z-index: 1;
}

.clear-both {
  clear: both;
}

.date-picker {
  width: 78%;
  padding: 7px;
  background: #F8F8F8;
  box-shadow: inset 0 0 0 1px rgba(51, 51, 51, 0.35);
  border-radius: 4px;
  border: 1px;
  height: 22px;
}

.react-datepicker__view-calendar-icon input {
  padding-left: 35px !important;
}

.rhap_button-clear {
  color: white !important;
}

.header {
  width: 100%;
  position: fixed;
  top: 0;
  background: rgb(8, 20, 47);
  z-index: 1001;
  padding: 0;
}

.header h1 {
  color: #FFF;
}

.avatarContainer {
  display: flex;
  justify-content: end;
  padding-block: 15px;
  width: 80px;
}

.avatarContainer1 {
  float: left;
  width: 10%;
  padding-top: 15px;
}

.avatarContainer1 svg {
  fill: #FFF;
}

.avatarContainer svg {
  fill: #FFF;
}

.headerTop {
  display: flex;
}

.file-container {
  width: 100px;
  height: 100px;
  background: #F8F8F8;
  border-radius: 6px;
}

.file-name-container {
  padding: 5px;
  padding-top: 10px;
  padding-bottom: 0px;
  width: 90px;
  height: 24px;
  background: #E1E1E1;
  position: relative;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
  color: #1F1F1F;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.file-name-img-container {
  top: 73px;
  padding-top: 2px;
}

.file-name-audio-container {
  padding-top: 2px;
}

.file-remove-btn {
  bottom: 95px;
  left: 75px;
}

.file-container-img {
  width: 100px;
  height: 100px;
}

.icon-container {
  justify-content: center;
  height: 76px;
}

.calender-icon-select {
  height: 18px;
  width: 20px;
  padding-right: 10px;
}

.calender-selection .calender-icon-filter {
  display: inline-block;
  float: left;
  margin-right: 5px;
  fill: rgb(79, 173, 166);
  height: 18px;
  width: 18px;
}

.dot-red {
  height: 8px;
  width: 8px;
  background-color: #EF374E;
  border-radius: 50%;
  display: inline-block;
}

.dot-4FADA6 {
  height: 8px;
  width: 8px;
  background-color: #4FADA6;
  border-radius: 50%;
  display: inline-block;
}

.dot-yellow {
  height: 8px;
  width: 8px;
  background-color: #F2CB15;
  border-radius: 50%;
  display: inline-block;
}

.shadow .control-select-inner {
  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13);
  border-radius: 6px;
  padding: 0.5rem;
}

.control-select-addon {
  color: #4FADA6;
}

.shadow .control-select-filter-inner {
  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13);
  border-radius: 6px;
  padding: 0.5rem;
}

.control-select-filter-addon {
  color: #4FADA6;
}

.rss-backdrop {
  clip-path: none !important;
  transform: none !important;
  padding-top: 0px !important;
}

.control-select-select.has-placeholder {
  color: #031C38;
  font-weight: 400;
  font-size: 15px;
}

.control-select-filter-select.has-placeholder {
  color: #031C38;
  font-weight: 400;
  font-size: 15px;
}

.swatch.intent-danger {
  background-color: #EF374E;
}

.horizontal-slider {
  width: 100%;
  max-width: 500px;
  height: 50px;
}

.horizontal-slider .example-track {
  top: 20px;
  height: 10px;
}

.example-track {
  position: relative;
  background: rgb(221, 221, 221);
}

.horizontal-slider .example-thumb {
  top: 10px;
  width: 35px;
  height: 35px;
  line-height: 11px;
}

.example-thumb {
  font-size: 0.9em;
  text-align: center;
  background-color: white;
  color: white;
  cursor: pointer;
  border: 0.6px solid #4FADA6;
  box-sizing: border-box;
  border-radius: 50%;
  padding-top: 11px;
}

.horizontal-slider .example-mark {
  margin: 0px 19px;
  bottom: calc(50% - 6px);
}

.example-mark {
  width: 10px;
  height: 10px;
  background-color: rgb(221, 221, 221);
  cursor: pointer;
  border-radius: 50%;
  vertical-align: middle;
}

.example-mark-completed {
  background: #4FADA6;
}

.horizontal-slider .example-track {
  top: 24px;
  height: 4px;
}

.example-track.example-track-1 {
  background: #4FADA6;
}

.example-track {
  position: relative;
  background: rgb(221, 221, 221);
}

.example-thumb svg {
  fill: #4FADA6;
}

.example-mark-last {
  left: unset !important;
  right: 0px;
  margin-right: 0px !important;
}

.example-mark-first {
  margin-left: 0px !important;
}

.thin-x-line {
  border: none;
  height: 0.5px;
  color: #fff;
  background-color: #fff;
}

.focus-area-select .control-input {
  border: none;
  height: 34px !important;
}

.standard-multi-select .control-input {
  height: 34px !important;
  box-shadow: inset 0 0 0 1px rgba(51, 51, 51, 0.35);
  border: none;
}

.loader-text {
  color: #A1A1A1;
  text-align: center;
  width: 100%;
  display: block;
}

.text {
  white-space: pre-wrap !important;
}

.bp3-menu-item .inner-text {
  flex: unset !important;
}

.bp3-overlay .bp3-menu {
  max-height: 300px !important;
}

.standard-tag .tags-tag {
  background-color: #ABE1DD;
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #1F1F1F;
  border-radius: 8px;
}

.text.selected {
  background-color: #ABE1DD;
  padding-left: 5px;
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #1F1F1F;
  border-radius: 8px;
}

.grey-bg {
  background: #F8F8F8;
  border-radius: 10px;
}

.image-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: flex-start;
  position: relative;
  width: 100%;
  background: #FFFFFF;
  margin: 5px;
}

.selected-image {
  width: 100%;
  margin-bottom: 20px;
}

.image-card {
  width: 77px;
  height: 76px;
  background: #F1F1F1;
  margin: 5px;
}

.red-border {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  cursor: text;
  border-radius: 4px;
  background-color: #fff;
  transition: all 125ms cubic-bezier(0.42, 0, 0.58, 1) 0ms;
  width: 100%;
  position: relative;
  border: 1px solid #cb1717;
  border-radius: 6px;
}

.light-gray-border {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  cursor: text;
  border-radius: 4px;
  background-color: #fff;
  transition: all 125ms cubic-bezier(0.42, 0, 0.58, 1) 0ms;
  width: 100%;
  position: relative;
  border: 1px solid #E1E1E1;
  border-radius: 6px;
}

.image-overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 1rem;
  background: #F9F9F9;
  border-radius: 13.61px;
}

.f-none {
  flex: none !important;
}

.pilot-header {
  position: sticky;
  top: 0px;
  z-index: 10;
}

.non-ideal-state {
  position: relative;
  display: flex;
  flex-direction: column;
  top: 300px;
  padding: 20px;
  align-items: center;
  text-align: center;
}

.row-separater-skeleton {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 10px;
}

.center-align-skeleton {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.box-scroll {
  flex-wrap: wrap;
}

.justify-center {
  justify-content: center;
}

.justify-end {
  justify-content: end;
}

.space-between {
  justify-content: space-between;
}

.space-evenly {
  justify-content: space-evenly;
}

.image-label {
  margin-top: 20px;
  line-height: 34px;
  padding: 5px 28px;
  font-size: 17px;
  font-weight: 600;
  width: 100%;
  min-width: 70px;
  background-color: white;
  color: #071C3E;
  box-shadow: inset 0 0 0 1px #071c3e;
  display: inline-block;
  cursor: pointer;
  text-align: center;
  background-color: transparent;
  white-space: nowrap;
  position: relative;
  transition: all 250ms ease-in-out 0ms;
  box-sizing: border-box;
  border-radius: 4px;
}

.legend {
  padding: 0px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.legend UL > LI {
  margin: 5px 7px 0 0 !important;
}

.legend UL > LI .swatch {
  margin-right: 2px !important;
}

.react-datepicker__year-dropdown--scrollable, .react-datepicker__month-dropdown--scrollable, .react-datepicker__month-year-dropdown--scrollable {
  max-height: 300px;
  height: 100%;
}

.react-datepicker__current-month, .react-datepicker__current-month--hasYearDropdown, .react-datepicker__current-month--hasMonthDropdown {
  pointer-events: none;
}

.react-datepicker__header__dropdown, .react-datepicker__header__dropdown--scroll {
  margin-top: 10px;
}

.react-datepicker__month-dropdown-container.react-datepicker__month-dropdown-container--scroll {
  background-color: #fff;
  padding: 2px 4px;
  max-width: 100px;
  width: 100%;
  border: 1px solid;
}

.react-datepicker__year-read-view, .react-datepicker__month-read-view, .react-datepicker__month-year-read-view {
  text-align: left;
}

.react-datepicker__year-read-view--down-arrow, .react-datepicker__month-read-view--down-arrow, .react-datepicker__month-year-read-view--down-arrow {
  right: 4px !important;
}

.react-datepicker__month-dropdown-container .react-datepicker__month-read-view--down-arrow, .react-datepicker__year-read-view--down-arrow {
  width: 6px !important;
  height: 6px !important;
  border-width: 2px 2px 0 0 !important;
  top: 1px !important;
}

.react-datepicker__year-dropdown-container--select, .react-datepicker__month-dropdown-container--select, .react-datepicker__month-year-dropdown-container--select, .react-datepicker__year-dropdown-container--scroll, .react-datepicker__month-dropdown-container--scroll, .react-datepicker__month-year-dropdown-container--scroll {
  background-color: #fff;
  padding: 2px 4px;
  max-width: 54px;
  width: 100%;
  margin: 0 !important;
  border: 1px solid;
}

.react-datepicker__header__dropdown, .react-datepicker__header__dropdown--scroll {
  display: flex;
  justify-content: center;
  padding: 0 8px;
  gap: 8px;
}

.support-link {
  text-decoration: underline;
  color: blue;
}

.formDiv .react-datepicker__year-dropdown {
  background-color: #f0f0f0;
  position: absolute;
  width: 26%;
  left: 61%;
  top: 60px;
  z-index: 1;
  text-align: center;
  border-radius: 0.3rem;
  border: 1px solid #aeaeae;
}

.formDiv .react-datepicker__year-option--selected {
  position: absolute;
  left: 6px;
}

.formDiv .react-datepicker__month-dropdown {
  background-color: #f0f0f0;
  position: absolute;
  width: 45%;
  left: 12%;
  top: 59px;
  z-index: 1;
  text-align: center;
  border-radius: 0.3rem;
  border: 1px solid #aeaeae;
}

.formDiv .react-datepicker__month-option--selected {
  position: absolute;
  left: 6px;
}

.header.myActionWrapper {
  height: 80px;
}
.header.myActionWrapper .avatarContainer div {
  display: none;
}

.button-cls {
  color: #000;
  text-align: center;
  font-family: Source Sans Pro;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
  margin-top: 63px;
}

.backOverlay.setupPin {
  padding-bottom: 10px !important;
  border-radius: 0 !important;
  margin: 0 !important;
  padding: 30px 0 0 0 !important;
}

.button-cls.createPin {
  margin-top: 0px !important;
}

.createPinWrapper {
  text-align: center;
  margin-top: 32px;
}

.react-confirm-alert-overlay.overlayPrompt.createPin {
  top: 78px !important;
}

.file-remove-btn-upload {
  bottom: 105px;
  left: 75px;
}

.gap-10 {
  gap: 10px;
}

.gap-12 {
  gap: 12px;
}

.overlay-height {
  max-height: 80vh;
  overflow: scroll;
}

.backOverlay-register {
  padding: 20px;
  margin: 5px;
  border-radius: 10px;
  background: #fff;
  padding-bottom: 60px;
}

.backOverlay-changePin {
  padding: 20px;
  margin: 5px;
  border-radius: 10px;
  background: #fff;
  padding-bottom: 60px;
}

[data-rsbs-overlay], [data-rsbs-backdrop], [data-rsbs-root]:after {
  z-index: 1000 !important;
  touch-action: auto !important;
  overscroll-behavior: auto !important;
}

.border-active-blue {
  border: 1px solid #4FADA6;
  border-radius: 6px !important;
}

.gap-7 {
  gap: 7px;
}

.accessdenied-tab {
  margin-bottom: 87px;
}
.accessdenied-tab button {
  margin-top: 30px;
  width: 90%;
}

.custom-white-control-select {
  color: white !important;
}

.commentary-content p {
  margin-bottom: 16px; /* Adjust the value as needed */
}

.hotel-selector-primary {
  color: #fff !important;
  text-transform: none !important;
  letter-spacing: 0px !important;
}

.portalOverlay {
  margin: 40px;
  border-radius: 10px;
  background: white;
  width: 320px;
  padding-top: 10px;
}

.text-left-imp {
  text-align: left !important;
}

.cancel-text {
  padding: 1rem 3rem 1rem 3rem;
}

.end-session {
  padding: 1rem 2rem 1rem 2.5rem;
  border-left: 1px solid #d1dbec;
}

.Non-ideal-state {
  margin: 100px !important;
}

.height-55 {
  height: 55px;
}

.height-55 {
  height: 55px;
}

.commentary-content p {
  margin-bottom: 16px; /* Adjust the value as needed */
}

.rpv-default-layout__toolbar {
  bottom: 0;
  top: unset !important;
  background: white !important;
  border-bottom: none !important;
  position: static !important;
  order: 2;
}

.rpv-default-layout__body {
  padding-top: 0 !important;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
}

.rpv-default-layout__container {
  border: none !important;
}

.full-screen-container {
  position: fixed;
  height: 100%;
  top: 0;
  z-index: 9999;
  background: white;
  width: 100vw;
  overflow: scroll;
}

.full-screen-container .rpv-default-layout__toolbar {
  margin: 0px !important;
}

.full-screen-container .rpv-default-layout__body {
  padding: 0px !important;
}

.full-screen-container .rpv-default-layout__toolbar {
  height: unset !important;
}

.full-screen-container .rpv-core__inner-page {
  background-color: #071C3E;
}

.full-screen-container .pdf-viewer-container {
  height: unset !important;
}

body:has(.full-screen-container) .nav-wrapper, body:has(.full-screen-container) .frame-header {
  display: none;
}

.text-area-style {
  padding: 24px 0px 8px 0px;
  border: 1px solid #E1E1E1;
}

.text-area-validate-style {
  padding: 24px 0px 8px 0px;
  border: 1px solid #CC3044;
}

.audit-form-style .control-input {
  padding-bottom: 16px;
}
.audit-form-style svg {
  padding-top: 32px;
}
.audit-form-style input {
  padding-top: 32px;
}

.validate-error .control-input {
  border: 1px solid #CC3044;
}

.myaudit-date-picker-form {
  width: -webkit-fill-available;
  padding: 12px 16px;
  border-radius: 0.5rem;
  border: 1px solid #D9D9D9;
  height: 24px;
}

.myaudit-date-picker-validate-form {
  width: -webkit-fill-available;
  padding: 25px 15px 10px 15px;
  border-radius: 0.5rem;
  border: 1px solid #CC3044;
}

.no-scroll {
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
}

.toast-content {
  margin-top: 70px;
}`, "",{"version":3,"sources":["webpack://./main.scss"],"names":[],"mappings":"AAAA,+CAAA;AACA;EACE,SAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA,gDAAA;AACA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA,iDAAA;AACA;EACE,aAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA,6CAAA;AACA;EACE,SAAA;AACF;;AAEA,wDAAA;AACA;EACE,sBAAA;AACF;;AAEA,8CAAA;AACA;EACE,eAAA;AACF;;AAEA,uDAAA;AACA;EACE,qBAAA;AACF;;AAEA,qDAAA;AACA;EACE,kBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA,+CAAA;AAEA;EACE,WAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA,wDAAA;AAEA;EACE,2BAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA,oDAAA;AACA;EACE,YAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,uBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,gDAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA,0DAAA;AAEA;EACE,uBAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAKA,oDAAA;AAEA;EACE,aAAA;AAHF;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,UAAA;AAHF;;AAMA,mDAAA;AACA;EACE,0BAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA,qDAAA;AAEA;EACE,2BAAA;AAJF;;AAOA;EACE,2BAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAOA,8CAAA;AAEA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,8BAAA;AALF;;AAQA;EACE,8BAAA;AALF;;AAQA,qDAAA;AACA;EACE,6BAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,4BAAA;AALF;;AAQA;EACE,4BAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA,iDAAA;AACA;EACE,UAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,aAAA;AALF;;AAQA;EACE,aAAA;AALF;;AAQA;EACE,aAAA;AALF;;AAQA;EACE,aAAA;AALF;;AAQA;EACE,aAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,oBAAA;AALF;;AAQA;EACE,oBAAA;AALF;;AAQA;EACE,oBAAA;AALF;;AAQA;EACE,oBAAA;AALF;;AAQA;EACE,oBAAA;AALF;;AAQA;EACE,oBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,oBAAA;AALF;;AAQA;EACE,oBAAA;AALF;;AAQA;EACE,oBAAA;AALF;;AAQA;EACE,qBAAA;AALF;;AAQA;EACE,qBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA,gDAAA;AACA;EACE,WAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,qBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA,gDAAA;AACA;EACE,yBAAA;AALF;;AAQA;EACE,oCAAA;AALF;;AAQA;EACE,kCAAA;AALF;;AAQA;EACE,6BAAA;AALF;;AAQA;EACE,uBAAA;AALF;;AAQA;EACE,4BAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,8BAAA;AALF;;AAQA;EACE,mFAAA;AALF;;AAQA;EACE,2BAAA;EACA,mBAAA;AALF;;AASA,yDAAA;AAEA;EACE,0BAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA,kDAAA;AAEA;EACE,kBAAA;AARF;;AAWA;EACE,eAAA;AARF;;AAWA;EACE,kBAAA;AARF;;AAWA;EACE,SAAA;AARF;;AAWA;EACE,SAAA;AARF;;AAWA;EACE,SAAA;AARF;;AAWA;EACE,UAAA;AARF;;AAWA;EACE,UAAA;AARF;;AAWA;EACE,WAAA;AARF;;AAWA;EACE,WAAA;AARF;;AAWA;EACE,UAAA;AARF;;AAWA;EACE,WAAA;AARF;;AAWA;EACE,WAAA;AARF;;AAWA;EACE,WAAA;AARF;;AAWA;EACE,UAAA;AARF;;AAWA;EACE,UAAA;AARF;;AAYA;EACE,WAAA;AATF;;AAYA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,kDAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AATF;;AAWA;EACE,6BAAA;AARF;;AAWA;EACE,uBAAA;AARF;;AAWA;EACE,WAAA;EACA,eAAA;EACA,MAAA;EAEA,0BAAA;EACA,aAAA;EACA,UAAA;AATF;;AAYA;EACE,WAAA;AATF;;AAYA;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AATF;;AAYA;EACE,WAAA;EACA,UAAA;EACA,iBAAA;AATF;;AAYA;EACE,UAAA;AATF;;AAYA;EACE,UAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AATF;;AAYA;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EAEA,8BAAA;EACA,+BAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAVF;;AAaA;EACE,SAAA;EACA,gBAAA;AAVF;;AAaA;EAEE,gBAAA;AAXF;;AAcA;EACE,YAAA;EACA,UAAA;AAXF;;AAcA;EACE,YAAA;EACA,aAAA;AAXF;;AAcA;EAGE,uBAAA;EACA,YAAA;AAbF;;AAgBA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AAbF;;AAgBA;EACE,WAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AAbF;;AAgBA;EACE,mFAAA;EACA,kBAAA;EACA,eAAA;AAbF;;AAgBA;EACE,cAAA;AAbF;;AAgBA;EACE,mFAAA;EACA,kBAAA;EACA,eAAA;AAbF;;AAgBA;EACE,cAAA;AAbF;;AAgBA;EAEE,0BAAA;EACA,0BAAA;EACA,2BAAA;AAbF;;AAgBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAbF;;AAgBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAbF;;AAgBA;EACE,yBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AAbF;;AAgBA;EACE,SAAA;EACA,YAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,8BAAA;AAbF;;AAgBA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAgBA;EACE,SAAA;EACA,WAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,8BAAA;AAbF;;AAgBA;EACE,aAAA;AAbF;;AAgBA;EACE,sBAAA;EACA,UAAA;EACA,4BAAA;AAbF;;AAgBA;EACE,2BAAA;AAbF;;AAgBA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;AAbF;;AAgBA;EACE,YAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,uBAAA;EACA,kDAAA;EACA,YAAA;AAbF;;AAgBA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AAbF;;AAgBA;EACE,gCAAA;AAbF;;AAgBA;EACE,sBAAA;AAbF;;AAgBA;EACE,4BAAA;AAbF;;AAgBA;EACE,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,yBAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,mBAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,eAAA;EACA,6BAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;AAbF;;AAgBA;EACE,WAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,wDAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,wDAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAbF;;AAiBA;EACE,qBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,QAAA;EACA,WAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAdF;;AAiBA;EACE,eAAA;AAdF;;AAiBA;EACE,uBAAA;AAdF;;AAiBA;EACE,oBAAA;AAdF;;AAiBA;EACE,8BAAA;AAdF;;AAiBA;EACE,6BAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,sBAAA;EACA,kBAAA;AAdF;;AAiBA;EAEE,uBAAA;EACA,yBAAA;EACA,0BAAA;AAfF;;AAmBA;EACE,8BAAA;AAhBF;;AAoBA;EACE,4BAAA;AAjBF;;AAqBA;EACE,iBAAA;EACA,YAAA;AAlBF;;AAqBA;EACE,oBAAA;AAlBF;;AAqBA;EACE,gBAAA;AAlBF;;AAqBA;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,gBAAA;AAlBF;;AAqBA;EACE,qBAAA;AAlBF;;AAqBA;EACE,qBAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,uBAAA;EACA,cAAA;EACA,QAAA;AAlBF;;AAqBA;EACE,0BAAA;EACA,WAAA;AAlBF;;AAqBA;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,SAAA;AAlBF;;AAqBA;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,SAAA;AAlBF;;AAqBA;EACE,YAAA;AAlBF;AAqBI;EACE,aAAA;AAnBN;;AAwBA;EACE,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,uCAAA;EAAA,+BAAA;EACA,gBAAA;AArBF;;AAyBA;EACE,+BAAA;EACA,2BAAA;EACA,oBAAA;EACA,8BAAA;AAtBF;;AAyBA;EACE,0BAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,oBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,UAAA;AAtBF;;AAyBA;EACE,SAAA;AAtBF;;AAyBA;EACE,SAAA;AAtBF;;AAyBA;EACE,gBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAtBF;;AAyBA;EACE,wBAAA;EACA,6BAAA;EACA,oCAAA;AAtBF;;AAyBA;EACE,yBAAA;EACA,6BAAA;AAtBF;;AAyBA;EACE,QAAA;AAtBF;;AA2BA;EAEE,mBAAA;AAzBF;AA2BE;EACE,gBAAA;EACA,UAAA;AAzBJ;;AA6BA;EACE,uBAAA;AA1BF;;AA6BA;EACE,mBAAA,EAAA,+BAAA;AA1BF;;AA6BA;EACE,sBAAA;EACA,+BAAA;EACA,8BAAA;AA1BF;;AA6BA;EACE,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AA1BF;;AA6BA;EACE,2BAAA;AA1BF;;AA6BA;EACE,4BAAA;AA1BF;;AA6BA;EACE,8BAAA;EACA,8BAAA;AA1BF;;AA6BA;EACE,wBAAA;AA1BF;;AA6BA;EACE,YAAA;AA1BF;;AA6BA;EACE,YAAA;AA1BF;;AA6BA;EACE,mBAAA,EAAA,+BAAA;AA1BF;;AA6BA;EACE,SAAA;EACA,qBAAA;EACA,4BAAA;EACA,8BAAA;EACA,2BAAA;EACA,QAAA;AA1BF;;AA6BA;EACE,yBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;AA1BF;;AA8BA;EACE,uBAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,sBAAA;AA3BF;;AA8BA;EACE,uBAAA;AA3BF;;AA8BA;EACE,wBAAA;AA3BF;;AA8BA;EACE,yBAAA;AA3BF;;AA8BA;EACE,wBAAA;AA3BF;;AA8BA;EACE,aAAA;AA3BF;;AA8BA;EACE,yBAAA;EACA,yBAAA;AA3BF;;AA8BA;EACE,yBAAA;EACA,yBAAA;AA3BF;;AA+BE;EACE,oBAAA;AA5BJ;AA+BE;EACE,iBAAA;AA7BJ;AAgCE;EACE,iBAAA;AA9BJ;;AAoCE;EACE,yBAAA;AAjCJ;;AAqCA;EACE,6BAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;AAlCF;;AAsCA;EACE,6BAAA;EACA,4BAAA;EACA,qBAAA;EACA,yBAAA;AAnCF;;AAsCA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAnCF;;AAuCA;EACE,gBAAA;AApCF","sourcesContent":["/*************** Width Styles *****************/\n.w-5 {\n  width: 5%;\n}\n\n.w-7 {\n  width: 7%;\n}\n\n.w-10 {\n  width: 10%;\n}\n\n.w-13 {\n  width: 13%;\n}\n\n.w-16 {\n  width: 16%;\n}\n\n.w-19 {\n  width: 19%;\n}\n\n.w-14 {\n  width: 14%;\n}\n\n.w-17 {\n  width: 17%;\n}\n\n.w-20 {\n  width: 20%;\n}\n\n.w-21 {\n  width: 21%;\n}\n\n.w-22 {\n  width: 22%;\n}\n\n.w-25 {\n  width: 25%;\n}\n\n.w-27 {\n  width: 27%;\n}\n\n.w-28 {\n  width: 28%;\n}\n\n.w-30 {\n  width: 30%;\n}\n\n.w-33 {\n  width: 33%;\n}\n\n.w-36 {\n  width: 36%;\n}\n\n.w-40 {\n  width: 40%;\n}\n\n.w-45 {\n  width: 45%;\n}\n\n.w-46 {\n  width: 46%;\n}\n\n.w-49 {\n  width: 49%;\n}\n\n.w-50 {\n  width: 50%;\n}\n\n.w-54 {\n  width: 54%;\n}\n\n.w-55 {\n  width: 55%;\n}\n\n.w-60 {\n  width: 60%;\n}\n\n.w-70 {\n  width: 70%;\n}\n\n.w-73 {\n  width: 73%;\n}\n\n.w-79 {\n  width: 79%;\n}\n\n.w-80 {\n  width: 80%;\n}\n\n.w-83 {\n  width: 83%;\n}\n\n.w-85 {\n  width: 85%;\n}\n\n.w-86 {\n  width: 86%;\n}\n\n.w-87 {\n  width: 87%;\n}\n\n.w-90 {\n  width: 90%;\n}\n\n.w-93 {\n  width: 93%;\n}\n\n.w-95 {\n  width: 95%;\n}\n\n.w-96 {\n  width: 96%;\n}\n\n.w-98 {\n  width: 98%;\n}\n\n.w-100 {\n  width: 100%;\n}\n\n.w-30px {\n  width: 30px;\n}\n\n.w-40px {\n  width: 30px;\n}\n\n.w-48px {\n  width: 48px;\n}\n\n.w-50px {\n  width: 50px;\n}\n\n.w-55px {\n  width: 55px;\n}\n\n.w-60px {\n  width: 60px;\n}\n\n.w-70px {\n  width: 70px;\n}\n\n.w-80px {\n  width: 80px !important;\n}\n\n.w-100px {\n  width: 100px;\n}\n\n.w-130px {\n  width: 130px;\n}\n\n.w-335px {\n  width: 335px;\n}\n\n/*************** Height Styles *****************/\n.h-0 {\n  height: 0px;\n}\n\n.h-8px {\n  height: 8px;\n}\n\n.h-13px {\n  height: 13px;\n}\n\n.h-25px {\n  height: 25px !important;\n}\n\n.h-30px {\n  height: 30px;\n}\n\n.h-55px {\n  height: 55px;\n}\n\n.h-70px {\n  height: 70px;\n}\n\n.h-100px {\n  height: 100px;\n}\n\n.h-100 {\n  height: 100%;\n}\n\n.h-70vh {\n  height: 70vh;\n}\n\n.h-120 {\n  height: 120px;\n}\n\n.min-hieght-100vh {\n  min-height: 100vh;\n}\n\n/*************** Display Styles *****************/\n.d-none {\n  display: none;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-inline-block {\n  display: inline-block;\n}\n\n.d-flex {\n  display: flex;\n}\n\n.d-grid {\n  display: grid;\n}\n\n/*************** Gap Styles *****************/\n.gap-15 {\n  gap: 15px;\n}\n\n/*************** Flex direction Styles *****************/\n.flex-direction-column {\n  flex-direction: column;\n}\n\n/*************** Flex Styles *****************/\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n/*************** Align content Styles *****************/\n.align-content-center {\n  align-content: center;\n}\n\n/*************** Align items Styles *****************/\n.align-items-start {\n  align-items: start;\n}\n\n.align-items-end {\n  align-items: end;\n}\n\n.align-items-center {\n  align-items: center;\n}\n\n.align-items-baseline {\n  align-items: baseline;\n}\n\n/*************** Float Styles *****************/\n.f-left {\n  float: left;\n}\n\n.f-right {\n  float: right;\n}\n\n/*************** Text Alignment Styles *****************/\n.text-left {\n  text-align: left !important;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-center {\n  text-align: center;\n}\n\n/*************** Text Color Styles *****************/\n.color-white {\n  color: white;\n}\n\n.color-red {\n  color: #FF3B30;\n}\n\n.color-green {\n  color: #58C3BB;\n}\n\n.color-007AFF {\n  color: #007AFF;\n}\n\n.color-4FADA6 {\n  color: #4FADA6;\n}\n\n.color-EF374E {\n  color: #EF374E;\n}\n\n.color-black {\n  color: black !important;\n}\n\n.color-8298B5 {\n  color: #8298B5;\n}\n\n.color-717171 {\n  color: #717171;\n}\n\n.color-08142f {\n  color: #08142f;\n}\n\n.color-58C3BB {\n  color: #58C3BB;\n}\n\n.color-ABE1DD {\n  color: #ABE1DD;\n}\n\n.color-F8E58A {\n  color: #F8E58A;\n}\n\n.color-F79BA6 {\n  color: #F79BA6;\n}\n\n.color-CC3044 {\n  color: #CC3044;\n}\n\n.color-1F1F1F {\n  color: #1F1F1F;\n}\n\n.color-919191 {\n  color: #919191 !important;\n}\n\n.color-071C3E {\n  color: #071C3E;\n}\n\n.color-979797 {\n  color: #979797;\n}\n\n.color-757575 {\n  color: #757575;\n}\n\n.color-15192080-important {\n  color: rgba(21, 25, 32, 0.5019607843) !important;\n}\n\n.color-031C38 {\n  color: #031C38;\n}\n\n/*************** Background Color Styles *****************/\n.background-white {\n  background-color: white;\n}\n\n.background-EEF9F8 {\n  background-color: #EEF9F8;\n}\n\n.background-FDEBED {\n  background-color: #FDEBED;\n}\n\n.background-f1f1f1 {\n  background: #f1f1f1;\n}\n\n.background-f7f8f8 {\n  background: #f7f8f8;\n}\n\n.background-08142f {\n  background: #08142f;\n}\n\n.background-E1E1E1 {\n  background: #E1E1E1;\n}\n\n.background-none {\n  background: none;\n}\n\n.background-58C3BB {\n  background: #58C3BB;\n}\n\n.background-ABE1DD {\n  background: #ABE1DD;\n}\n\n.background-EEF9F8 {\n  background: #EEF9F8;\n}\n\n.background-F8E58A {\n  background: #F8E58A;\n}\n\n.background-F79BA6 {\n  background: #F79BA6;\n}\n\n.background-CC3044 {\n  background: #CC3044;\n}\n\n.background-EF374E {\n  background: #EF374E;\n}\n\n.background-4FADA6 {\n  background: #4FADA6;\n}\n\n.background-071C3E {\n  background: #071C3E;\n}\n\n.background-717171 {\n  background: #717171;\n}\n\n.background-DEBA12 {\n  background: #DEBA12;\n}\n\n.background-1F1F1F {\n  background: #1F1F1F;\n}\n\n.background-8298B5 {\n  background: #8298B5;\n}\n\n.background-919191 {\n  background: #919191;\n}\n\n.background-F2CB15 {\n  background: #F2CB15;\n}\n\n.background-071C3E-important {\n  background: #071C3E !important;\n}\n\n.background-F5F7FB-important {\n  background: #F5F7FB !important;\n}\n\n/*************** Fill Color Styles *****************/\n.fill-58c3bb {\n  fill: #58c3bb;\n}\n\n.fill-white {\n  fill: white;\n}\n\n.fill-979797 {\n  fill: #979797;\n}\n\n.fill-919191 {\n  fill: #919191;\n}\n\n.fill-white {\n  fill: #fff;\n}\n\n/*************** Font Size Styles *****************/\n.f-10 {\n  font-size: 10px !important;\n}\n\n.f-12 {\n  font-size: 12px !important;\n}\n\n.f-13 {\n  font-size: 13px;\n}\n\n.f-14 {\n  font-size: 14px !important;\n}\n\n.f-15 {\n  font-size: 15px !important;\n}\n\n.f-17 {\n  font-size: 17px;\n}\n\n.f-18 {\n  font-size: 18px;\n}\n\n.f-20 {\n  font-size: 20px;\n}\n\n.f-22 {\n  font-size: 22px;\n}\n\n.f-24 {\n  font-size: 24px;\n}\n\n.f-28 {\n  font-size: 28px;\n}\n\n/*************** Font Weight Styles *****************/\n.fw-600 {\n  font-weight: 600 !important;\n}\n\n.fw-400 {\n  font-weight: 400 !important;\n}\n\n.fw-bold {\n  font-weight: bold;\n}\n\n/*************** Font Styles *****************/\n.font-normal {\n  font-style: normal;\n}\n\n.font-italic {\n  font-style: italic;\n}\n\n.sans-font {\n  font-family: \"Source Sans Pro\";\n}\n\n.times-roman {\n  font-family: \"Times New Roman\";\n}\n\n/*************** Line Height Styles *****************/\n.lh-unset {\n  line-height: unset !important;\n}\n\n.lh-12 {\n  line-height: 12px;\n}\n\n.lh-16 {\n  line-height: 16px !important;\n}\n\n.lh-18 {\n  line-height: 18px !important;\n}\n\n.lh-20 {\n  line-height: 20px;\n}\n\n.lh-22 {\n  line-height: 22px;\n}\n\n.lh-24 {\n  line-height: 24px;\n}\n\n.lh-25 {\n  line-height: 25px;\n}\n\n.lh-28 {\n  line-height: 28px;\n}\n\n.lh-34 {\n  line-height: 34px;\n}\n\n/*************** Padding Styles *****************/\n.p-0 {\n  padding: 0;\n}\n\n.p-5 {\n  padding: 5px;\n}\n\n.p-10 {\n  padding: 10px;\n}\n\n.p-15 {\n  padding: 15px;\n}\n\n.p-17 {\n  padding: 15px;\n}\n\n.p-20 {\n  padding: 20px;\n}\n\n.p-26 {\n  padding: 26px;\n}\n\n.pl-2 {\n  padding-left: 2px;\n}\n\n.pl-3 {\n  padding-left: 3px;\n}\n\n.pl-5 {\n  padding-left: 5px;\n}\n\n.pl-10 {\n  padding-left: 10px;\n}\n\n.pl-15 {\n  padding-left: 15px;\n}\n\n.pl-20 {\n  padding-left: 20px;\n}\n\n.pb-0 {\n  padding-bottom: 0px;\n}\n\n.pb-6 {\n  padding-bottom: 6px;\n}\n\n.pb-10 {\n  padding-bottom: 10px;\n}\n\n.pb-15 {\n  padding-bottom: 15px;\n}\n\n.pb-20 {\n  padding-bottom: 20px;\n}\n\n.pb-25 {\n  padding-bottom: 25px;\n}\n\n.pb-50 {\n  padding-bottom: 50px;\n}\n\n.pb-70 {\n  padding-bottom: 70px;\n}\n\n.pt-3 {\n  padding-top: 3px;\n}\n\n.pt-5 {\n  padding-top: 5px;\n}\n\n.pt-6 {\n  padding-top: 6px;\n}\n\n.pt-10 {\n  padding-top: 10px;\n}\n\n.pt-12 {\n  padding-top: 12px;\n}\n\n.pt-15 {\n  padding-top: 15px;\n}\n\n.pt-20 {\n  padding-top: 20px;\n}\n\n.pt-25 {\n  padding-top: 25px;\n}\n\n.pt-30 {\n  padding-top: 30px;\n}\n\n.pt-35 {\n  padding-top: 35px;\n}\n\n.pt-80 {\n  padding-top: 80px;\n}\n\n.pt-120 {\n  padding-top: 120px;\n}\n\n.pt-180 {\n  padding-top: 180px;\n}\n\n.pt-190 {\n  padding-top: 190px;\n}\n\n.pt-200 {\n  padding-top: 200px;\n}\n\n.pb-5 {\n  padding-bottom: 5px;\n}\n\n.pb-15 {\n  padding-bottom: 15px;\n}\n\n.pb-60 {\n  padding-bottom: 60px;\n}\n\n.pb-85 {\n  padding-bottom: 85px;\n}\n\n.pb-100 {\n  padding-bottom: 100px;\n}\n\n.pb-280 {\n  padding-bottom: 280px;\n}\n\n.pr-0 {\n  padding-right: 0px;\n}\n\n.pr-2 {\n  padding-right: 2px;\n}\n\n.pr-3 {\n  padding-right: 3px;\n}\n\n.pr-5 {\n  padding-right: 5px;\n}\n\n.pr-10 {\n  padding-right: 10px;\n}\n\n.pr-15 {\n  padding-right: 15px;\n}\n\n.pr-22 {\n  padding-right: 22px;\n}\n\n.pr-20 {\n  padding-right: 20px;\n}\n\n/*************** Margin Styles *****************/\n.m-0 {\n  margin: 0px;\n}\n\n.m-3 {\n  margin: 3px;\n}\n\n.m-5 {\n  margin: 5px;\n}\n\n.m-7 {\n  margin: 7px;\n}\n\n.m-10 {\n  margin: 10px;\n}\n\n.m-15 {\n  margin: 15px;\n}\n\n.m-0-auto {\n  margin: 0px auto;\n}\n\n.mt-0 {\n  margin-top: 0px;\n}\n\n.mt-5 {\n  margin-top: 5px;\n}\n\n.mt-10 {\n  margin-top: 10px;\n}\n\n.mt-15 {\n  margin-top: 10px;\n}\n\n.mt-20 {\n  margin-top: 20px;\n}\n\n.mt-30 {\n  margin-top: 30px;\n}\n\n.mt-40 {\n  margin-top: 40px;\n}\n\n.mt-60 {\n  margin-top: 60px;\n}\n\n.mt-80 {\n  margin-top: 80px;\n}\n\n.mt-95 {\n  margin-top: 95px;\n}\n\n.mt-130 {\n  margin-top: 130px;\n}\n\n.mt-150 {\n  margin-top: 150px;\n}\n\n.mt-165 {\n  margin-top: 165px;\n}\n\n.mt-170 {\n  margin-top: 170px;\n}\n\n.mt-175 {\n  margin-top: 175px;\n}\n\n.mt-200 {\n  margin-top: 200px;\n}\n\n.mtn-20px {\n  margin-top: -20px;\n}\n\n.mb-0 {\n  margin-bottom: 0px;\n}\n\n.mb-1-5rem {\n  margin-bottom: 1.5rem;\n}\n\n.mt-1-5rem {\n  margin-top: 1.5rem;\n}\n\n.mb-5 {\n  margin-bottom: 5px;\n}\n\n.mb-10 {\n  margin-bottom: 10px;\n}\n\n.mb-15 {\n  margin-bottom: 15px;\n}\n\n.mb-20 {\n  margin-bottom: 20px;\n}\n\n.mb-30 {\n  margin-bottom: 30px;\n}\n\n.mb-60 {\n  margin-bottom: 60px;\n}\n\n.mb-70 {\n  margin-bottom: 70px;\n}\n\n.ml-10p {\n  margin-left: 10%;\n}\n\n.ml-5 {\n  margin-left: 5px;\n}\n\n.ml-10 {\n  margin-left: 10px;\n}\n\n.ml-15 {\n  margin-left: 15px;\n}\n\n.ml-20 {\n  margin-left: 20px;\n}\n\n.mln-10px {\n  margin-left: -10px;\n}\n\n.mr-5 {\n  margin-right: 5px;\n}\n\n.mr-10 {\n  margin-right: 10px;\n}\n\n.mr-12 {\n  margin-right: 12px;\n}\n\n.mr-15 {\n  margin-right: 15px;\n}\n\n.mr-22 {\n  margin-right: 22px;\n}\n\n.mr-30 {\n  margin-right: 30px;\n}\n\n.mrn-10px {\n  margin-right: -10px;\n}\n\n/*************** Border Styles *****************/\n.black-border-1 {\n  border: 1px solid #E1E1E1;\n}\n\n.border-grey-1 {\n  border: 1px solid #E1E1E1 !important;\n}\n\n.border-bottom-grey-1 {\n  border-bottom: 1px solid lightgrey;\n}\n\n.border-top-d1dbec-1 {\n  border-top: 1px solid #d1dbec;\n}\n\n.border-right-1 {\n  border-right: 1px solid;\n}\n\n.border-1 {\n  border: 1px solid !important;\n}\n\n.border-radius-4 {\n  border-radius: 4px;\n}\n\n.border-radius-5 {\n  border-radius: 5px;\n}\n\n.border-radius-7 {\n  border-radius: 7px;\n}\n\n.border-radius-8 {\n  border-radius: 8px;\n}\n\n.border-radius-10 {\n  border-radius: 10px;\n}\n\n.border-radius-60 {\n  border-radius: 60px !important;\n}\n\n.box-shadow {\n  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13);\n}\n\n.box-none {\n  box-shadow: none !important;\n  margin-bottom: 10px;\n}\n\n/*************** Text Decoration Styles *****************/\n.text-underline {\n  text-decoration: underline;\n}\n\n.text-none {\n  text-decoration: none;\n}\n\n/*************** Position Styles *****************/\n.position-absolute {\n  position: absolute;\n}\n\n.position-fixed {\n  position: fixed;\n}\n\n.position-relative {\n  position: relative;\n}\n\n.top-3 {\n  top: -3px;\n}\n\n.top-10 {\n  top: 10px;\n}\n\n.top-20 {\n  top: 20px;\n}\n\n.top-100 {\n  top: 100px;\n}\n\n.top-200 {\n  top: 200px;\n}\n\n.top-350px {\n  top: -350px;\n}\n\n.bottom-1 {\n  bottom: 1px;\n}\n\n.right-7 {\n  right: 7px;\n}\n\n.right-10 {\n  right: 10px;\n}\n\n.right-19 {\n  right: 19px;\n}\n\n.right-25 {\n  right: 25px;\n}\n\n.left-25 {\n  left: 25px;\n}\n\n.zIndex-1 {\n  z-index: 1;\n}\n\n.clear-both {\n  clear: both;\n}\n\n.date-picker {\n  width: 78%;\n  padding: 7px;\n  background: #F8F8F8;\n  box-shadow: inset 0 0 0 1px rgba(51, 51, 51, 0.35);\n  border-radius: 4px;\n  border: 1px;\n  height: 22px;\n}\n\n.react-datepicker__view-calendar-icon input {\n  padding-left: 35px !important;\n}\n\n.rhap_button-clear {\n  color: white !important;\n}\n\n.header {\n  width: 100%;\n  position: fixed;\n  top: 0;\n  background: rgb(8, 20, 47);\n  z-index: 1001;\n  padding: 0;\n}\n\n.header h1 {\n  color: #FFF;\n}\n\n.avatarContainer {\n  display: flex;\n  justify-content: end;\n  padding-block: 15px;\n  width: 80px;\n}\n\n.avatarContainer1 {\n  float: left;\n  width: 10%;\n  padding-top: 15px;\n}\n\n.avatarContainer1 svg {\n  fill: #FFF;\n}\n\n.avatarContainer svg {\n  fill: #FFF;\n}\n\n.headerTop {\n  display: flex;\n}\n\n.file-container {\n  width: 100px;\n  height: 100px;\n  background: #F8F8F8;\n  border-radius: 6px;\n}\n\n.file-name-container {\n  padding: 5px;\n  padding-top: 10px;\n  padding-bottom: 0px;\n  width: 90px;\n  height: 24px;\n  background: #E1E1E1;\n  position: relative;\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  font-family: Source Sans Pro;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 16px;\n  color: #1F1F1F;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.file-name-img-container {\n  top: 73px;\n  padding-top: 2px;\n}\n\n.file-name-audio-container {\n  padding-top: 2px;\n}\n\n.file-remove-btn {\n  bottom: 95px;\n  left: 75px;\n}\n\n.file-container-img {\n  width: 100px;\n  height: 100px;\n}\n\n.icon-container {\n  justify-content: center;\n  height: 76px;\n}\n\n.calender-icon-select {\n  height: 18px;\n  width: 20px;\n  padding-right: 10px;\n}\n\n.calender-selection .calender-icon-filter {\n  display: inline-block;\n  float: left;\n  margin-right: 5px;\n  fill: rgb(79, 173, 166);\n  height: 18px;\n  width: 18px;\n}\n\n.dot-red {\n  height: 8px;\n  width: 8px;\n  background-color: #EF374E;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.dot-4FADA6 {\n  height: 8px;\n  width: 8px;\n  background-color: #4FADA6;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.dot-yellow {\n  height: 8px;\n  width: 8px;\n  background-color: #F2CB15;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.shadow .control-select-inner {\n  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13);\n  border-radius: 6px;\n  padding: 0.5rem;\n}\n\n.control-select-addon {\n  color: #4FADA6;\n}\n\n.shadow .control-select-filter-inner {\n  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13);\n  border-radius: 6px;\n  padding: 0.5rem;\n}\n\n.control-select-filter-addon {\n  color: #4FADA6;\n}\n\n.rss-backdrop {\n  -webkit-clip-path: none !important;\n  clip-path: none !important;\n  transform: none !important;\n  padding-top: 0px !important;\n}\n\n.control-select-select.has-placeholder {\n  color: #031C38;\n  font-weight: 400;\n  font-size: 15px;\n}\n\n.control-select-filter-select.has-placeholder {\n  color: #031C38;\n  font-weight: 400;\n  font-size: 15px;\n}\n\n.swatch.intent-danger {\n  background-color: #EF374E;\n}\n\n.horizontal-slider {\n  width: 100%;\n  max-width: 500px;\n  height: 50px;\n}\n\n.horizontal-slider .example-track {\n  top: 20px;\n  height: 10px;\n}\n\n.example-track {\n  position: relative;\n  background: rgb(221, 221, 221);\n}\n\n.horizontal-slider .example-thumb {\n  top: 10px;\n  width: 35px;\n  height: 35px;\n  line-height: 11px;\n}\n\n.example-thumb {\n  font-size: 0.9em;\n  text-align: center;\n  background-color: white;\n  color: white;\n  cursor: pointer;\n  border: 0.6px solid #4FADA6;\n  box-sizing: border-box;\n  border-radius: 50%;\n  padding-top: 11px;\n}\n\n.horizontal-slider .example-mark {\n  margin: 0px 19px;\n  bottom: calc(50% - 6px);\n}\n\n.example-mark {\n  width: 10px;\n  height: 10px;\n  background-color: rgb(221, 221, 221);\n  cursor: pointer;\n  border-radius: 50%;\n  vertical-align: middle;\n}\n\n.example-mark-completed {\n  background: #4FADA6;\n}\n\n.horizontal-slider .example-track {\n  top: 24px;\n  height: 4px;\n}\n\n.example-track.example-track-1 {\n  background: #4FADA6;\n}\n\n.example-track {\n  position: relative;\n  background: rgb(221, 221, 221);\n}\n\n.example-thumb svg {\n  fill: #4FADA6;\n}\n\n.example-mark-last {\n  left: unset !important;\n  right: 0px;\n  margin-right: 0px !important;\n}\n\n.example-mark-first {\n  margin-left: 0px !important;\n}\n\n.thin-x-line {\n  border: none;\n  height: 0.5px;\n  color: #fff;\n  background-color: #fff;\n}\n\n.focus-area-select .control-input {\n  border: none;\n  height: 34px !important;\n}\n\n.standard-multi-select .control-input {\n  height: 34px !important;\n  box-shadow: inset 0 0 0 1px rgba(51, 51, 51, 0.35);\n  border: none;\n}\n\n.loader-text {\n  color: #A1A1A1;\n  text-align: center;\n  width: 100%;\n  display: block;\n}\n\n.text {\n  white-space: pre-wrap !important;\n}\n\n.bp3-menu-item .inner-text {\n  flex: unset !important;\n}\n\n.bp3-overlay .bp3-menu {\n  max-height: 300px !important;\n}\n\n.standard-tag .tags-tag {\n  background-color: #ABE1DD;\n  font-family: \"Source Sans Pro\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #1F1F1F;\n  border-radius: 8px;\n}\n\n.text.selected {\n  background-color: #ABE1DD;\n  padding-left: 5px;\n  font-family: \"Source Sans Pro\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #1F1F1F;\n  border-radius: 8px;\n}\n\n.grey-bg {\n  background: #F8F8F8;\n  border-radius: 10px;\n}\n\n.image-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  align-items: flex-start;\n  position: relative;\n  width: 100%;\n  background: #FFFFFF;\n  margin: 5px;\n}\n\n.selected-image {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.image-card {\n  width: 77px;\n  height: 76px;\n  background: #F1F1F1;\n  margin: 5px;\n}\n\n.red-border {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  cursor: text;\n  border-radius: 4px;\n  background-color: #fff;\n  transition: all 125ms cubic-bezier(0.42, 0, 0.58, 1) 0ms;\n  width: 100%;\n  position: relative;\n  border: 1px solid #cb1717;\n  border-radius: 6px;\n}\n\n.light-gray-border {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  cursor: text;\n  border-radius: 4px;\n  background-color: #fff;\n  transition: all 125ms cubic-bezier(0.42, 0, 0.58, 1) 0ms;\n  width: 100%;\n  position: relative;\n  border: 1px solid #E1E1E1;\n  border-radius: 6px;\n}\n\n.image-overlay {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  row-gap: 1rem;\n  background: #F9F9F9;\n  border-radius: 13.61px;\n}\n\n.f-none {\n  flex: none !important;\n}\n\n.pilot-header {\n  position: sticky;\n  top: 0px;\n  z-index: 10;\n}\n\n.non-ideal-state {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  top: 300px;\n  padding: 20px;\n  align-items: center;\n  text-align: center;\n}\n\n.row-separater-skeleton {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-top: 10px;\n}\n\n.center-align-skeleton {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.box-scroll {\n  flex-wrap: wrap;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-end {\n  justify-content: end;\n}\n\n.space-between {\n  justify-content: space-between;\n}\n\n.space-evenly {\n  justify-content: space-evenly;\n}\n\n.image-label {\n  margin-top: 20px;\n  line-height: 34px;\n  padding: 5px 28px;\n  font-size: 17px;\n  font-weight: 600;\n  width: 100%;\n  min-width: 70px;\n  background-color: white;\n  color: #071C3E;\n  box-shadow: inset 0 0 0 1px #071c3e;\n  display: inline-block;\n  cursor: pointer;\n  text-align: center;\n  background-color: transparent;\n  white-space: nowrap;\n  position: relative;\n  transition: all 250ms ease-in-out 0ms;\n  box-sizing: border-box;\n  border-radius: 4px;\n}\n\n.legend {\n  padding: 0px !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.legend UL > LI {\n  margin: 5px 7px 0 0 !important;\n}\n\n.legend UL > LI .swatch {\n  margin-right: 2px !important;\n}\n\n.react-datepicker__year-dropdown--scrollable, .react-datepicker__month-dropdown--scrollable, .react-datepicker__month-year-dropdown--scrollable {\n  max-height: 300px;\n  height: 100%;\n}\n\n.react-datepicker__current-month, .react-datepicker__current-month--hasYearDropdown, .react-datepicker__current-month--hasMonthDropdown {\n  pointer-events: none;\n}\n\n.react-datepicker__header__dropdown, .react-datepicker__header__dropdown--scroll {\n  margin-top: 10px;\n}\n\n.react-datepicker__month-dropdown-container.react-datepicker__month-dropdown-container--scroll {\n  background-color: #fff;\n  padding: 2px 4px;\n  max-width: 100px;\n  width: 100%;\n  border: 1px solid;\n}\n\n.react-datepicker__year-read-view, .react-datepicker__month-read-view, .react-datepicker__month-year-read-view {\n  text-align: left;\n}\n\n.react-datepicker__year-read-view--down-arrow, .react-datepicker__month-read-view--down-arrow, .react-datepicker__month-year-read-view--down-arrow {\n  right: 4px !important;\n}\n\n.react-datepicker__month-dropdown-container .react-datepicker__month-read-view--down-arrow, .react-datepicker__year-read-view--down-arrow {\n  width: 6px !important;\n  height: 6px !important;\n  border-width: 2px 2px 0 0 !important;\n  top: 1px !important;\n}\n\n.react-datepicker__year-dropdown-container--select, .react-datepicker__month-dropdown-container--select, .react-datepicker__month-year-dropdown-container--select, .react-datepicker__year-dropdown-container--scroll, .react-datepicker__month-dropdown-container--scroll, .react-datepicker__month-year-dropdown-container--scroll {\n  background-color: #fff;\n  padding: 2px 4px;\n  max-width: 54px;\n  width: 100%;\n  margin: 0 !important;\n  border: 1px solid;\n}\n\n.react-datepicker__header__dropdown, .react-datepicker__header__dropdown--scroll {\n  display: flex;\n  justify-content: center;\n  padding: 0 8px;\n  gap: 8px;\n}\n\n.support-link {\n  text-decoration: underline;\n  color: blue;\n}\n\n.formDiv .react-datepicker__year-dropdown {\n  background-color: #f0f0f0;\n  position: absolute;\n  width: 26%;\n  left: 61%;\n  top: 60px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.3rem;\n  border: 1px solid #aeaeae;\n}\n\n.formDiv .react-datepicker__year-option--selected {\n  position: absolute;\n  left: 6px;\n}\n\n.formDiv .react-datepicker__month-dropdown {\n  background-color: #f0f0f0;\n  position: absolute;\n  width: 45%;\n  left: 12%;\n  top: 59px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.3rem;\n  border: 1px solid #aeaeae;\n}\n\n.formDiv .react-datepicker__month-option--selected {\n  position: absolute;\n  left: 6px;\n}\n\n.header.myActionWrapper {\n  height: 80px;\n}\n.header.myActionWrapper .avatarContainer div {\n  display: none;\n}\n\n.button-cls {\n  color: #000;\n  text-align: center;\n  font-family: Source Sans Pro;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  text-decoration-line: underline;\n  margin-top: 63px;\n}\n\n.backOverlay.setupPin {\n  padding-bottom: 10px !important;\n  border-radius: 0 !important;\n  margin: 0 !important;\n  padding: 30px 0 0 0 !important;\n}\n\n.button-cls.createPin {\n  margin-top: 0px !important;\n}\n\n.createPinWrapper {\n  text-align: center;\n  margin-top: 32px;\n}\n\n.react-confirm-alert-overlay.overlayPrompt.createPin {\n  top: 78px !important;\n}\n\n.file-remove-btn-upload {\n  bottom: 105px;\n  left: 75px;\n}\n\n.gap-10 {\n  gap: 10px;\n}\n\n.gap-12 {\n  gap: 12px;\n}\n\n.overlay-height {\n  max-height: 80vh;\n  overflow: scroll;\n}\n\n.backOverlay-register {\n  padding: 20px;\n  margin: 5px;\n  border-radius: 10px;\n  background: #fff;\n  padding-bottom: 60px;\n}\n\n.backOverlay-changePin {\n  padding: 20px;\n  margin: 5px;\n  border-radius: 10px;\n  background: #fff;\n  padding-bottom: 60px;\n}\n\n[data-rsbs-overlay], [data-rsbs-backdrop], [data-rsbs-root]:after {\n  z-index: 1000 !important;\n  touch-action: auto !important;\n  overscroll-behavior: auto !important;\n}\n\n.border-active-blue {\n  border: 1px solid #4FADA6;\n  border-radius: 6px !important;\n}\n\n.gap-7 {\n  gap: 7px;\n}\n\n.accessdenied-tab {\n  margin-bottom: 87px;\n}\n.accessdenied-tab button {\n  margin-top: 30px;\n  width: 90%;\n}\n\n.custom-white-control-select {\n  color: white !important;\n}\n\n.commentary-content p {\n  margin-bottom: 16px; /* Adjust the value as needed */\n}\n\n.hotel-selector-primary {\n  color: #fff !important;\n  text-transform: none !important;\n  letter-spacing: 0px !important;\n}\n\n.portalOverlay {\n  margin: 40px;\n  border-radius: 10px;\n  background: white;\n  width: 320px;\n  padding-top: 10px;\n}\n\n.text-left-imp {\n  text-align: left !important;\n}\n\n.cancel-text {\n  padding: 1rem 3rem 1rem 3rem;\n}\n\n.end-session {\n  padding: 1rem 2rem 1rem 2.5rem;\n  border-left: 1px solid #d1dbec;\n}\n\n.Non-ideal-state {\n  margin: 100px !important;\n}\n\n.height-55 {\n  height: 55px;\n}\n\n.height-55 {\n  height: 55px;\n}\n\n.commentary-content p {\n  margin-bottom: 16px; /* Adjust the value as needed */\n}\n\n.rpv-default-layout__toolbar {\n  bottom: 0;\n  top: unset !important;\n  background: white !important;\n  border-bottom: none !important;\n  position: static !important;\n  order: 2;\n}\n\n.rpv-default-layout__body {\n  padding-top: 0 !important;\n  padding-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.rpv-default-layout__container {\n  border: none !important;\n}\n\n.full-screen-container {\n  position: fixed;\n  height: 100%;\n  top: 0;\n  z-index: 9999;\n  background: white;\n  width: 100vw;\n  overflow: scroll;\n}\n\n.full-screen-container .rpv-default-layout__toolbar {\n  margin: 0px !important;\n}\n\n.full-screen-container .rpv-default-layout__body {\n  padding: 0px !important;\n}\n\n.full-screen-container .rpv-default-layout__toolbar {\n  height: unset !important;\n}\n\n.full-screen-container .rpv-core__inner-page {\n  background-color: #071C3E;\n}\n\n.full-screen-container .pdf-viewer-container {\n  height: unset !important;\n}\n\nbody:has(.full-screen-container) .nav-wrapper, body:has(.full-screen-container) .frame-header {\n  display: none;\n}\n\n.text-area-style {\n  padding: 24px 0px 8px 0px;\n  border: 1px solid #E1E1E1;\n}\n\n.text-area-validate-style {\n  padding: 24px 0px 8px 0px;\n  border: 1px solid #CC3044;\n}\n\n.audit-form-style .control-input {\n  padding-bottom: 16px;\n}\n.audit-form-style svg {\n  padding-top: 32px;\n}\n.audit-form-style input {\n  padding-top: 32px;\n}\n\n.validate-error .control-input {\n  border: 1px solid #CC3044;\n}\n\n.myaudit-date-picker-form {\n  width: -webkit-fill-available;\n  padding: 12px 16px;\n  border-radius: 0.5rem;\n  border: 1px solid #D9D9D9;\n  height: 24px;\n}\n\n.myaudit-date-picker-validate-form {\n  width: -webkit-fill-available;\n  padding: 25px 15px 10px 15px;\n  border-radius: 0.5rem;\n  border: 1px solid #CC3044;\n}\n\n.no-scroll {\n  overflow: hidden;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n}\n\n.toast-content {\n  margin-top: 70px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
